import { createFileRoute } from "@tanstack/react-router";
import TeVamosALlamar from "../pages/TeVamosALlamar";

export const Route = createFileRoute("/te-vamos-a-llamar")({
  component: TeVamosALlamar,
});
